import Page from '@app/components/layout/page/page';
import { useGetTransport } from '@shared/api';
import TransportTable from './components/transport-table';

export interface Transport {
  createdDate: string;
  modifiedDate: string;
  description: string;
  notesAndAssumptions: string[];
  uuid: string;
}

const TransportPage: React.FC = () => {
  const data = useGetTransport();

  return (
    <Page name="Transport" page="subpage">
      <TransportTable {...data} />
    </Page>
  );
};

export default TransportPage;
